import {createAction} from '@reduxjs/toolkit'

import {DeliveryAddress, OrderInfo} from '../interfaces'

export const changeDeliveryAddress = createAction<DeliveryAddress>('deliveryManager/changeDeliveryAddress')
export const changeOrderInfo = createAction<OrderInfo>('deliveryManager/changeOrderInfo')

export const toggleVirtualPhoneNumber = createAction('deliveryManager/toggleVirtualPhoneNumber')

export const editPersonalCustomsCode = createAction<string>('deliveryManager/editPersonalCustomsCode')
